import { IntlShape } from 'react-intl';
import { decodeHTML } from 'entities';
import supportedLanguages from '@whitelabel/helpers/supportedLanguages';
import { ICurrency } from './types/currencyTypes';

export const localizePathname = (pathname: string, locale: string) => {
  const pathnameArray = pathname.split('/');
  if (Object.keys(supportedLanguages).includes(pathnameArray[1])) {
    pathnameArray[1] = locale;
  } else {
    pathnameArray.splice(1, 0, locale);
  }
  return pathnameArray.join('/');
};

export const formatCurrency = (intl: IntlShape, value: number | bigint, currency: ICurrency): string => {
  const { format, isZeroDecimal } = currency;

  const formattedValue = intl.formatNumber(
    value,
    isZeroDecimal
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  );

  const formattedCurrency = decodeHTML(format.replace(/%\.\df/, formattedValue));

  return formattedCurrency;
};
